import { TagsV2 } from '@frontend/api-tag';
import { useTranslation } from '@frontend/i18n';
import { useAppScopeStore } from '@frontend/scope';
import { theme } from '@frontend/theme';
import { Button, Dot, usePopoverDialog } from '@frontend/design-system';
import { useFaxSearchFiltersShallowStore } from '../../stores';
import { FaxSearchFilterPopover } from './fax-search-filter-popover';
import { FaxSearchFilterStatus } from './fax-search-filter-status';

export const FaxSearchFilters = () => {
  const { t } = useTranslation('fax');
  const { selectedLocationIds, selectedOrgId } = useAppScopeStore();

  const { faxSearchFilters } = useFaxSearchFiltersShallowStore('faxSearchFilters');
  const filtersPopoverMenu = usePopoverDialog<HTMLButtonElement>({ placement: 'bottom-end' });

  const hasFilters = Object.values(faxSearchFilters).some((value) => {
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    return !!value;
  });

  const { data: locationTagsQuery } = TagsV2.Queries.useListTagsQuery({
    request: { orgId: selectedOrgId, groupIds: selectedLocationIds },
  });

  const locationTags = locationTagsQuery?.tags ?? [];

  return (
    <div
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        flexGrow: 1,
        gap: theme.spacing(1),
      }}
    >
      {hasFilters && <FaxSearchFilterStatus filters={faxSearchFilters} />}
      <Button
        {...filtersPopoverMenu.getTriggerProps()}
        label={t('Filter faxes')}
        css={{
          position: 'relative',
          padding: theme.spacing(1),
          '.button-icon': {
            color: theme.colors.neutral70,
          },
        }}
        iconName='filter-alt'
        variant='tertiary'
        size='large'
      >
        {hasFilters && (
          <Dot
            color='primary'
            css={{
              width: theme.spacing(1.5),
              height: theme.spacing(1.5),
              top: 3,
              right: 1,
              border: `1.5px solid ${theme.colors.white}`,
            }}
          />
        )}
      </Button>
      <FaxSearchFilterPopover popoverProps={filtersPopoverMenu} tags={locationTags} />
    </div>
  );
};
